import { updateDoc, doc, getDoc } from "@firebase/firestore";
import { hideLoading, showLoading } from "./item-categories-edit-slice";
import { editCategories } from "../item-categories-list/item-categories-list-slice";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";

// export const getItemCategoriesDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemCategoriesEdit getItemCategoriesDataService error: ", e);
//     }
// };

export const editItemCategoriesService = async (dispatch, db, coll, id, formData) => {
    dispatch(showLoading());
    try {
        await updateDoc(doc(db, coll, id), formData);
        // Wait for the document to be updated
        await new Promise(resolve => setTimeout(resolve, 1000));
        const docSnap = await getDoc(doc(db, coll, id));
        const updatedData = docSnap.data();
        const data = {
            ...updatedData,
            id: id,
        };
        dispatch(showSuccessSnackbar('Updated successfully!'));
        dispatch(editCategories(data));
    } catch(e) {
        dispatch(showErrorSnackbar('Update failed! Please, try again.'));
        console.error("ItemCategoriesEdit editItemCategoriesService error: ", e);
    }
    dispatch(hideLoading());
};
